import { atom } from 'jotai'

export const submittingFlowFormAtom = atom(false)
